
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Candle } from 'components/Candle'
import { Link } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Am 5. März 2020 stirbt im Universitätsspital Lausanne eine 74-jährige Frau.
  Sie ist die erste Covid-Tote der Schweiz.
    </p>
    <div className='centered'>
  <div className='candlewrapper'>
    <Candle sex='f' pos={10} className='marked' mdxType="Candle" />
  </div>
    </div>
    <p>
  Drei Tage später erliegt ein 76-Jähriger Mann aus dem Kanton Basel-Landschaft
  dem Virus. Kurz darauf stirbt auch ein 80-jähriger Mann aus der Region
  Mendrisio.
    </p>
    <div className='centered'>
  <div className='candlewrapper'>
    <Candle sex='m' pos={10} className='marked' mdxType="Candle" />
    <Candle sex='m' pos={10} className='marked' mdxType="Candle" />
  </div>
    </div>
    <p>
Vor einem Jahr waren diese drei Todesfälle noch eigene 
Nachrichtenmeldungen wert. Doch schon bald tauchten die 
Verstorbenen nur noch als Zahl auf – anonymisiert in der 
Statistik der Corona-Toten. Bis zu 100 Menschen am Tag 
verstarben in der Schweiz an den Folgen einer Infektion 
mit Sars-CoV-2, praktisch unbeachtet von Politik und 
Öffentlichkeit. Gut 90 Prozent der Opfer waren über 
70 Jahre alt, Hunderte aber auch jünger. Viele von ihnen 
starben einsam.
    </p>
    <p>
 Mit diesem Beitrag sollen die Schicksale hinter den Zahlen 
 fassbarer werden. Er wurde ursprünglich im Dezember 2020 
 publiziert, als die <Link allowWordWrap href='431861410672' mdxType="Link">Schweiz 5000 Corona-Tote zählte</Link>. Aus 
 aktuellem Anlass schalten wir das Stück nun erneut auf. Denn 
 mittlerweile hat das Coronavirus gemäss Zahlen aus den Kantonen 
 landesweit schon über 10’000 Menschenleben gefordert.
    </p>
    <p>
  <b>
Jede Kerze steht dabei für einen Menschen, der in der Schweiz an Covid-19 gestorben ist.
  </b>
    </p>
    <p>
Die Verstorbenen sind nach Wochen gruppiert, rote Kerzen stehen für Frauen, blaue für Männer. Bei manchen stehen Namen und ein Zitat aus der Todesanzeige.
    </p>
    <p>
Bei einigen Verstorbenen haben wir auch die Geschichte in einem Link hinterlegt. Mit diesen Erzählungen sollen die Angehörigen eine Stimme erhalten. Sie sind genauso betroffen wie die Zehntausenden schwer Erkrankten.
    </p>
    <p>
Sie alle sind die Opfer dieser Pandemie. Kein einziges sollte vergessen gehen.</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;